module.exports = __webpack_public_path__ + "static/media/fly0009.ac4bfcbc.webp";